module.exports = __webpack_public_path__ + "img/adulto11.deada488.jpg";